import Cookies from 'js-cookie';

// STRS represent a list of values that are stored inside the kajabi_ct cookie object
const STRS_to_shorties = {
  utm_source: 'us',
  utm_medium: 'um',
  utm_campaign: 'uca',
  utm_term: 'ut',
  utm_content: 'uco',
  utm_keyword: 'uk',
  gclid: 'gc',
  fbclid: 'fc',
  msclid: 'msc',
  WickedSource: 'ws',
  WickedMedium: 'wm',
  WickedCampaign: 'wc',
  WickedID: 'wi',
  WickedTerm: 'wt',
  WickedKeyword: 'wk',
};

const COOKIE_NAME = 'kajabi_ct';

export function getKajabiCtCookieValue() {
  const kajabi_cookie = Cookies.get(COOKIE_NAME);

  if (!kajabi_cookie || kajabi_cookie === '') {
    return '';
  }

  let urlString = '';
  const cookies = JSON.parse(kajabi_cookie);

  for (let cookie in cookies) {
    let thisCookie = cookies[cookie];
    for (let tag in thisCookie) {
      let thisObj = thisCookie[tag];
      for (let stringKey in thisObj) {
        let stringValue = thisObj[stringKey];
        if (cookie == 0) cookie = '';
        if (
          cookie != 0 &&
          Object.hasOwnProperty.call(STRS_to_shorties, stringKey)
        ) {
          const shortie = STRS_to_shorties[stringKey];
          stringKey = shortie;
        }
        urlString += `&${stringKey}${cookie}=${stringValue}`;
      }
    }
  }

  return urlString;
}
